export default "__VITE_PUBLIC_ASSET__9472d18c__"